export const query = {
  auth: 'auth',
  sync: 'sync',
  settings: 'settings',
  settingsHash: 'settingsHash',
  localize: 'localize',
  friends: 'friends',
  location: 'location',
  storeBadge: 'storeBadge',
  tap: 'tap',
  leagues: 'leagues',
};
